import { searchTags } from './reducers';
export default searchTags;
